import type * as SchemaTypes from '../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UsersForPerformanceResultQueryVariables = SchemaTypes.Exact<{
  filter?: SchemaTypes.InputMaybe<SchemaTypes.UserFilteringRule>;
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  sort?: SchemaTypes.InputMaybe<SchemaTypes.UserSortingRule>;
}>;


export type UsersForPerformanceResultQuery = (
  { __typename: 'Query' }
  & { users: (
    { __typename: 'PaginatedUser' }
    & Pick<SchemaTypes.PaginatedUser, 'count'>
    & { items: Array<(
      { __typename: 'SuperAdminUser' }
      & PerformanceResultUser_SuperAdminUser_Fragment
    ) | (
      { __typename: 'TenantUser' }
      & PerformanceResultUser_TenantUser_Fragment
    )> }
  ) }
);

export type PerformanceResultUser_SuperAdminUser_Fragment = { __typename: 'SuperAdminUser' };

export type PerformanceResultUser_TenantUser_Fragment = (
  { __typename: 'TenantUser' }
  & Pick<SchemaTypes.TenantUser, 'id' | 'name'>
);

export type PerformanceResultUserFragment = PerformanceResultUser_SuperAdminUser_Fragment | PerformanceResultUser_TenantUser_Fragment;

export const PerformanceResultUserFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultUser on User {
  ... on TenantUser {
    id
    name
  }
}
    `;
export const UsersForPerformanceResultDocument = /*#__PURE__*/ gql`
    query UsersForPerformanceResult($filter: UserFilteringRule, $pagination: Pagination, $sort: UserSortingRule) {
  users(filter: $filter, pagination: $pagination, sort: $sort) {
    count
    items {
      ...PerformanceResultUser
    }
  }
}
    ${PerformanceResultUserFragmentDoc}`;

/**
 * __useUsersForPerformanceResultQuery__
 *
 * To run a query within a React component, call `useUsersForPerformanceResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForPerformanceResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersForPerformanceResultQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useUsersForPerformanceResultQuery(baseOptions?: Apollo.QueryHookOptions<UsersForPerformanceResultQuery, UsersForPerformanceResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersForPerformanceResultQuery, UsersForPerformanceResultQueryVariables>(UsersForPerformanceResultDocument, options);
      }
export function useUsersForPerformanceResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersForPerformanceResultQuery, UsersForPerformanceResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersForPerformanceResultQuery, UsersForPerformanceResultQueryVariables>(UsersForPerformanceResultDocument, options);
        }
export function useUsersForPerformanceResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersForPerformanceResultQuery, UsersForPerformanceResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersForPerformanceResultQuery, UsersForPerformanceResultQueryVariables>(UsersForPerformanceResultDocument, options);
        }
export type UsersForPerformanceResultQueryHookResult = ReturnType<typeof useUsersForPerformanceResultQuery>;
export type UsersForPerformanceResultLazyQueryHookResult = ReturnType<typeof useUsersForPerformanceResultLazyQuery>;
export type UsersForPerformanceResultSuspenseQueryHookResult = ReturnType<typeof useUsersForPerformanceResultSuspenseQuery>;
export type UsersForPerformanceResultQueryResult = Apollo.QueryResult<UsersForPerformanceResultQuery, UsersForPerformanceResultQueryVariables>;